import { schemaCommon } from "components/Reusable/Bit/FormikSchema"
import * as yup from "yup"

const schemaPurchaseFull = yup
  .object({
    amount: schemaCommon.amount,
    senderName: schemaCommon.firstName,
    senderLastName: schemaCommon.lastName,
    recipientEmail: schemaCommon.recipientEmail,
    phoneNumber: schemaCommon.phoneNumber,
    recipientName: schemaCommon.fullName,
    senderMobilePhone: schemaCommon.phoneNumber,
    senderEmail: schemaCommon.email,
    checkedOne: schemaCommon.checkbox,
    quantity: schemaCommon.qauntity,
  })
  .defined()

const schemaPurchaseShort = yup
  .object({
    amount: schemaCommon.amount,
    senderName: schemaCommon.firstName,
    senderLastName: schemaCommon.lastName,
    senderMobilePhone: schemaCommon.phoneNumber,
    senderEmail: schemaCommon.email,
    checkedOne: schemaCommon.checkbox,
    quantity: schemaCommon.qauntity,
  })
  .defined()

export default { schemaPurchaseFull, schemaPurchaseShort }
